import { useEffect, useState, useRef } from 'react'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import {NavbarTopAdmin, NavbarBottomAdmin} from '../admin/components'
import { useNavigate } from 'react-router-dom'
import AddImg from '../admin/components/addImg'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { sostituisci } from '../../redux/artista'
import DivBottom from '../userNotAuth/components/divBottom'
import { RotatingLines } from "react-loader-spinner"

let tipoCucinaArr = []

function AddFoodTruck() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        altro: '',
        descrizione: '',
        nome: '',
        fb: '',
        città: '',
        idUser: localStorage.getItem('id'),
        regione: '',
        telefono: '',
        specialità: '',
        tipoCucina: [],
        url: '',
        youtube: '',
        video: ''
    })
    const [msg, setMsg] = useState({ foto: null, telefono: null })
    const [text, setText] = useState({ emailValidate: '' })
    const [foto, setFoto] = useState([])
    const [msgProgress, setMsgProgress] = useState({ string: null, failed: null, submit: null })//barra del loader dopo submit 
    const [validateSpecialità, setValidateSpecialità] = useState(null)//messaggio campo vuoto in genere
    const [tipoCucinaMsg, setTipoCucinaMsg] = useState(null)
    const numFoto = [0, 1, 2] // NUMERO MASSIMO DI FOTO (è l'index nel loop in html) ----------

    const descrizione = useRef()
    const telefono = useRef()
    const specialità = useRef()
    const altro = useRef()// altra specialità in options

    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (formData.specialità === '') {
            setValidateSpecialità('*** Campo obbligatorio ***'); window.scrollTo(0, 250)
            specialità.current.style.border = '1px solid red'; return
        } else
            if (formData.specialità === 'Altro' && formData.altro === '') {
                setValidateSpecialità('*** Campo obbligatorio ***'); window.scrollTo(0, 400); return
            } else
                if (formData.tipoCucina.length === 0) {
                    setTipoCucinaMsg('*** Almeno 1 tipo cucina ***'); window.scrollTo(0, 250); return
                } else
                    if (formData.telefono && /^[0-9\s-]+$/.test(formData.telefono) === false) {
                        setMsg({ telefono: '*** Campo numerico ***' }); window.scrollTo(0, 750)
                        telefono.current.style.border = '1px solid red'; return
                    } else
                        if (!validRegex.test(formData.email) || formData.email === '') {
                            setText({ emailValidate: 'Email non valida' })
                            window.scrollTo(0, 1000); return
                        }
        // ---------------- SE TUTTO E' IN CHECK --------------------
        setMsgProgress({ submit: 'Caricamento in corso...' })
        const object = { ...formData, foto: foto }

        try {//chiamata a server per insert in mysql del foodTruck creato
            const res = await axios.post(`/insertFoodTruck`, object)
            if (res.data === 'Success') {
                dispatch(sostituisci(object))
                setTimeout(() => {
                    setMsgProgress({ string: null })
                    navigate('/addFoodTruckSuccess', { replace: true })
                }, 1500)
            }
        } catch (err) { setMsgProgress({ string: '*** Creazione foodTruck fallita...riprova ***', submit: null }); console.error(err); return }
    }
    function handleChange(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setFormData({ ...formData, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 
        setValidateSpecialità(null); setText({ emailValidate: '' }); setMsg({ email: null, telefono: null }); setMsgProgress({ failed: null })
        descrizione.current.style.border = '1px solid black'; telefono.current.style.border = '1px solid black'

        if (name === 'telefono') {
            if (/^[0-9\s-]+$/.test(inputValue) === false && inputValue) { setMsg({ telefono: '*** Campo numerico ***' }) }
        }
        if (name === 'specialità' && value === 'Altro') {
            altro.current.style.display = 'block'
        } else
            if (name === 'specialità' && value !== 'Altro' && altro.current.style.display === 'block') {
                altro.current.style.display = 'none'
            }
        if (name === 'altro') setFormData({ ...formData, specialità: inputValue })
    }
    const videoChange = async (e) => {
        if (e.target.files[0]) {
            const ETarget = e.target.files[0]
            if (ETarget.type.startsWith('video/')) {// video conforme
                if (ETarget.size > 100000000) {
                    setMsgProgress({ ...msgProgress, string: '*** Video troppo grande...max 100 mega ***' })
                    return
                }
                const v = document.getElementById('progress')
                v.style.width = '94%'; v.style.transition = 'width 40s'; document.getElementById('container').style.border = '1px solid black'
                document.getElementById('rotaryVideo').style.display = 'block'
                setMsgProgress({ ...msgProgress, string: 'Attendere...upload video in corso' })
                // ----------------- controllo durata del video in secondi ----------------
                const videoForDurata = document.createElement('video')
                videoForDurata.src = URL.createObjectURL(ETarget)
                videoForDurata.onloadedmetadata = async function () {
                    const duration = videoForDurata.duration
                    if (duration > 300) {
                        setMsgProgress({ ...msgProgress, string: '*** Video troppo lungo (max 5 min) ***' })
                        window.URL.revokeObjectURL(videoForDurata.src)
                        document.getElementById('rotaryVideo').style.display = 'none'

                    } else {// ------ ACCETTAZIONE VIDEO ----------------------------------------   
                        let extens = ETarget.name.substring(ETarget.name.lastIndexOf('.') + 1)// ricavo l'estensione
                        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                        let result = ''
                        const charactersLength = characters.length
                        for (let i = 0; i < 15; i++) {
                            result += characters.charAt(Math.floor(Math.random() * charactersLength))
                        }
                        const zxc = `ZE_${result}.${extens}`// aggiungo ZE alla stringa random che darà il nome al video
                        document.getElementById('upload-video').disabled = true

                        function uploadThenSuccess(videoName) {
                            setMsgProgress({ ...msgProgress, string: 'Video caricato con successo' })
                            setFormData({ ...formData, video: videoName }) //formData2.video è il nome che andrà in MYSQL
                            v.style.transition = 'width 0.1s'; v.style.width = '100%'; document.getElementById('container').style.border = '1px solid black'
                            document.getElementById('lblVideo').style.display = 'none' // +video
                            document.getElementById('rotaryVideo').style.display = 'none'
                            document.getElementById('upload-video').disabled = false
                        }
                        function uploadThenFailed() {
                            document.getElementById('rotaryVideo').style.display = 'none'
                            setMsgProgress({ ...msgProgress, string: '*** Problemi con il server...riprova ***' })
                            v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
                            document.getElementById('upload-video').disabled = false
                            document.getElementById('upload-video').value = ''
                        }
                        const fd = new FormData(); let flagCompress

                        if (ETarget.size > 25000000) {//video > 25 mega non lo mando al server Heroku perchè lo saturerebbe in sovraccarico
                            flagCompress = 'compress_off'
                        } else {//video < 25 mega può essere compresso dal server
                            flagCompress = 'compress_on'
                        }
                        fd.append('video', ETarget); fd.append('nomeVideo', zxc); fd.append('stato', 'siAwsBucket')
                        try {
                            const res = await axios.post(`/convertVideo/${flagCompress}`, fd, {
                                headers: { "Content-Type": "multipart/form-data" }
                            })
                            if (res.data === 'success') {
                                if (flagCompress === 'compress_on') uploadThenSuccess(`ZE_${result}.mp4`)
                                if (flagCompress === 'compress_off') uploadThenSuccess(zxc)
                            } else uploadThenFailed()
                        } catch (err) { console.log("Errore durante l'upload", err) }
                    }
                }
            }
            else {
                //video type non conforme
                setMsgProgress({ ...msgProgress, string: '*** Tipo video non conforme ***' })
                e.target.value = ""; return
            }
        }
    }
    const videoRemove = async (e) => {
        const v = document.getElementById('progress')
        v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
        document.getElementById('upload-video').value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                setFormData({ ...formData, video: null })
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('lblVideo').style.display = 'block'//visualizzo '+video'  
                }, 50)
            }, speed)
        }

        try {
            axios.delete(`/delete-video/${formData.video}`)
        } catch (err) { setMsgProgress({ ...msgProgress, string: '*** Problemi con la connessione ***' }); console.error(err); return }
        removeFadeOut(document.getElementById('videoPreview'), 200)
        removeFadeOut(document.getElementById('iconaDelVideo'), 200)
        setMsgProgress({ ...msgProgress, string: null })
    }
    function handleTipoCucina(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        if (inputValue === true) {
            tipoCucinaArr.push(name)
        } else
            if (inputValue === false) {
                tipoCucinaArr = tipoCucinaArr.filter(item => item !== name)
            }
        setFormData({ ...formData, [name]: inputValue, tipoCucina: tipoCucinaArr })
        setTipoCucinaMsg(null)
    }
    useEffect(() => {//settaggio delle foto e opzioni Evento se si proviene da 'confirmAddEVento' 
        window.scrollTo(0, 0)
        for (let h = 1; h < numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
            document.getElementById('upload-photo' + (h)).disabled = true
        }
    }, [])
    // useEffect(() => { console.log('foto:', foto) }, [foto])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <div className='container' style={{ marginBottom: '3rem', marginTop: '6rem' }}>
            <p onClick={() => {
                navigate('/foodTruck', { replace: true })
            }}
                style={{
                    fontSize: 'xx-large', cursor: 'pointer', backgroundColor: 'lightgrey', borderRadius: '50%', float: 'right',
                    width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>X
            </p>

            <h2 style={{ display: 'inline' }}>Aggiungi un Food Truck</h2>

            <p style={{ margin: '1rem 0 3rem 0' }}><i>Aggiungi un FoodTruck/Banco gastronomico per poter essere contattato dagli organizzatori
                degli eventi.</i>
            </p>
            <form onSubmit={handleSubmit}>
                <div className="col-md-6"></div>
                <label htmlFor='nome'>Nome FoodTruck *</label>
                <input className="form-control fw-bold" style={{ width: '50%' }}
                    name="nome"
                    maxLength={45}
                    onChange={handleChange}
                    required
                    type="text" />

                <label htmlFor='città' className='mt-4'>Città *</label>
                <input className="form-control fw-bold" style={{ width: '50%' }}
                    name="città"
                    maxLength={45}
                    onChange={handleChange}
                    required
                    type="text" />

                <label htmlFor='regione' className='mt-4'>Regione *</label>
                <input className="form-control fw-bold" style={{ width: '50%' }}
                    name="regione"
                    maxLength={35}
                    onChange={handleChange}
                    required
                    type="text" />

                {/* ------------------ TIPO CUCINA --------------- */}
                {tipoCucinaMsg && <p style={{ color: 'red', marginTop: '2em' }}>{tipoCucinaMsg}</p>}

                <h5 style={{ marginTop: '1rem' }}>TIPO DI CUCINA *</h5>
                <div className='mt-3' style={{ display: 'grid', gridTemplateColumns: '2rem 1fr', gap: '4px' }}>
                    <div><input type='checkbox'
                        name='italiana'
                        checked={formData.cucinaItaliana}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Cucina italiana tradizionale</div>

                    <div><input type='checkbox'
                        name='hamburger'
                        checked={formData.hamburger}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Hamburger & Fast Food</div>

                    <div><input type='checkbox'
                        name='etnica'
                        checked={formData.etnica}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Etnica/Internazionale</div>

                    <div><input type='checkbox'
                        name='vegetariana'
                        checked={formData.vegetariana}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Vegetariana</div>

                    <div><input type='checkbox'
                        name='vegana'
                        checked={formData.vegana}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Vegana</div>

                    <div><input type='checkbox'
                        name='dolci'
                        checked={formData.dolci}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Dolci & Gelati</div>

                    <div><input type='checkbox'
                        name='bar'
                        checked={formData.bar}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Bar/Cocktail/Birre/Frullati/Centrifugati</div>

                    <div><input type='checkbox'
                        name='griglia'
                        checked={formData.griglia}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Griglia & Barbecue
                        <p style={{ color: 'maroon', fontSize: 'small', marginLeft: '5px' }}><i>Carne e pesce alla brace, arrosticini. </i></p>
                    </div>
                </div>

                {/* ---------------------- SPECIALITA' ------------------------- */}
                <label htmlFor='tipologia' className='mt-4'>Specialità *</label>
                <select className="form-select mt-1 fw-bold" aria-label="Default select example" style={{ width: 'auto' }}
                    name="specialità" ref={specialità}
                    onChange={handleChange} >
                    <option value=''></option>
                    <option value="Arancini e supplì">Arancini e supplì</option>
                    <option value="Asado">Asado</option>
                    <option value="Barbecue (BBQ)">Barbecue (BBQ)</option>
                    <option value="Caffè e bevande speciali">Caffè e bevande speciali</option>
                    <option value="Cous Cous">Cous Cous</option>
                    <option value="Cucina asiatica">Cucina asiatica</option>
                    <option value="Gelato">Gelato/Dessert</option>
                    <option value="Hamburger e hot dog">Hamburger e hot dog</option>
                    <option value="Hummus e Falafel">Hummus e Falafel</option>
                    <option value="Kebab">Kebab</option>
                    <option value="Moussaka">Moussaka</option>
                    <option value="Opzioni salutari e vegane">Opzioni salutari e vegane</option>
                    <option value="Paella">Paella</option>
                    <option value="Panini con porchetta">Panini con porchetta</option>
                    <option value="Panzerotti e calzoni fritti">Panzerotti e calzoni fritti</option>
                    <option value="Piadine">Piadine</option>
                    <option value="picanha">Picanha</option>
                    <option value="Tacos e cucina messicana">Tacos e cucina messicana</option>
                    <option value="Altro">Altro</option>
                </select>
                <div ref={altro} style={{ display: 'none', margin: '16px 0 0 5px' }}>
                    <label>Inserisci la specialità del tuo FoodTruck</label>
                    <input className="form-control fw-bold mt-1"
                        name="altro"
                        maxLength={45}
                        onChange={handleChange}
                        placeholder='es. patatine fritte'
                        type="text" />
                </div>
                {validateSpecialità && <p style={{ color: 'red' }}><i>{validateSpecialità}</i></p>}

                <h4 style={{ marginTop: '3rem' }}>Descrivi la tua attività *</h4>
                <p><i style={{ color: 'marron' }}>Ad esempio qualche particolare importante delle tue offerte gastronomiche...</i></p>
                <textarea style={{ padding: '5px' }} className='form-control' ref={descrizione}
                    name="descrizione"
                    rows='10'
                    maxLength={2000}
                    onChange={handleChange}
                >
                </textarea>

                <label htmlFor='telefono' className='mt-3'>Telefono </label>
                <input className='form-control fw-bold' style={{ width: '50%' }} ref={telefono}
                    name='telefono'
                    maxLength={20}
                    onChange={handleChange}
                    type='text' />
                {msg.telefono && <p style={{ color: 'red' }}><i>{msg.telefono}</i></p>}


                <label htmlFor='email' className='mt-3'>Email * </label>
                <input className="form-control fw-bold"
                    name="email"
                    onChange={handleChange}
                    type="text"
                    required />
                {text.emailValidate && <p style={{ color: 'red' }}>{text.emailValidate}</p>}

                <h5 style={{ fontFamily: 'sans-serif', marginTop: '3rem' }}>LINK</h5>
                <div style={{ marginLeft: '1rem' }}>
                    <label htmlFor='email' className='mt-1'>URL sito web</label>
                    <input className="form-control fw-bold"
                        name="url"
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.zona-eventi.it/'
                        type="text" />

                    <label htmlFor='email' className='mt-3'>URL Facebook</label>
                    <input className="form-control fw-bold"
                        name="fb"
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.facebook.com/'
                        type="text" />

                    <label htmlFor='email' className='mt-3'>URL YouTube</label>
                    <input className="form-control fw-bold"
                        name="youtube"
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.youtube.com/'
                        type="text" />
                </div>

                {/* ------------------------ Aggiungi immagini ------------------------- */}
                <AddImg numero={[0, 1, 2]} folder={''} invioFoto={(e) => { setFoto(e) }} />
                <br /><br />

                {/* ----------------------- Aggiungi video ------------------- */}
                <div>
                    <h4 style={{ marginTop: '0rem' }}>AGGIUNGI VIDEO (max 5 min)</h4>
                    <p style={{ opacity: '.7' }}><i>*** opzionale ***</i></p>
                    <div style={{ border: '2px solid cornflowerblue', width: '200px', height: '130px', textAlign: 'center', margin: '2em 0 0 3em', borderRadius: '5px' }}>
                        <label htmlFor="upload-video" style={{ cursor: 'pointer' }} id='lblVideo'>
                            + Video
                            <span id="rotaryVideo" style={{ display: 'none' }}>
                                <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                            </span>
                        </label>
                        {formData.video &&
                            <div>
                                <div style={{ marginTop: '-27px' }}>
                                    <button style={{ marginLeft: '9rem', border: 'transparent', backgroundColor: 'transparent' }}
                                        onClick={videoRemove} id={'iconaDelVideo'} type='button'>
                                        ❌
                                    </button>
                                </div>
                                <div>
                                    {/* ------------- preview del video proveniente da MYSQL ------------ */}
                                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${formData.video}`} id={'videoPreview'}
                                        style={{ width: '197px', height: '128px', borderRadius: '5px' }} controls />
                                </div>
                            </div>
                        }
                        <input id='upload-video' style={{ opacity: '0', fontSize: '0px' }}
                            type='file'
                            name='video'
                            accept="video/*"
                            onChange={videoChange} />
                    </div>

                    {/* ------------ barra di avanzamento ----------------------- */}
                    <div style={{ width: '35%', backgroundColor: 'transparent', margin: '1em 0 0 1em' }} id='container'>
                        <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise' }} id='progress'>
                        </div>
                    </div>
                    {msgProgress.string && <p style={{ color: 'navy', margin: '0 0 0 1em' }}><i>{msgProgress.string}</i></p>}
                </div>

                <hr />
                {msgProgress.submit &&
                    <p>{msgProgress.submit}<RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' /></p>
                }
                <p className='mt-5'><i>* campi obbligatori</i></p>
                <div className='mt-2'>
                    <button className='btn btn-secondary' onClick={() => {
                        navigate('/', { replace: true })
                    }}>Indietro
                    </button>
                    <button type='submit' className='btn btn-primary' style={{ marginLeft: '2rem' }}>Avanti</button>
                </div>
            </form>
        </div>
        <DivBottom />
    </>)
}
export default AddFoodTruck